import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../../../schoolselector/schoolselectorservice.service";
import { DataService_Locker } from "../../shared/data.service";

@Component({
	selector: "app-export-lockers",
	templateUrl: "./export-lockers.component.html",
	styleUrls: ["./export-lockers.component.css"],
})
export class ExportLockersComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private LockerService: DataService_Locker
	) {}

	ngOnInit(): void {
		this.loadFormatOptions();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.School = school;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	subscription: any;

	School: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "District";

	AssignableOptionID: any = -1;
	lstAssignableOption: any = [
		{
			ID: -1,
			Desc: "All",
		},
		{
			ID: 1,
			Desc: "Unassigned",
		},
		{
			ID: 0,
			Desc: "Already Assigned",
		},
	];

	ShowStudentID: any = true;

	LoadingOptions: any = false;
	FormatOptionID: any = 1;
	lstFormatOptions: any = [];

	IsProcessing: any = false;
	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.LockerService.LockerFormatSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOptionID = next.ID;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onExport() {
		this.errorMessage = "";

		this.IsProcessing = true;

		var result = this.LockerService.LockerExport(this.School.SchoolID, this.AssignableOptionID, this.ShowStudentID == true ? 1 : 0, this.FormatOptionID);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				var Data: any = response[0];

				if (Data != undefined) {
					var a = document.createElement("a"); //Create <a>

					var FileName = "Export_";

					if (this.School.SchoolID > 0) {
						FileName += this.School.SchoolNumber;
					} else {
						FileName += this.School.SchoolName;
					}
					// FileName += "_" + this.StudentActiveOption.Desc;
					// FileName += "_" + this.GuardianOption.Desc;
					// FileName += "_" + this.GuardianActiveOption.Desc;
					// FileName += "_" + this.EmailOption.Desc;

					//Text tab
					if (this.FormatOptionID == 1) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//Text comma
					else if (this.FormatOptionID == 2) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//CSV
					else if (this.FormatOptionID == 3) {
						a.href = "data:text/csv;base64," + response[0];
						a.download = FileName + ".csv";
						a.click(); //Downloaded file
					}
				} else {
					this.errorMessage = "Error Exporting Data";
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
